import { render } from "./SearchCourseByCategoryContent.vue?vue&type=template&id=ea5c2512&scoped=true"
import script from "./SearchCourseByCategoryContent.vue?vue&type=script&lang=js"
export * from "./SearchCourseByCategoryContent.vue?vue&type=script&lang=js"

import "./SearchCourseByCategoryContent.vue?vue&type=style&index=0&id=ea5c2512&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea5c2512"]])

export default __exports__